import { getCarouselImages } from './getCarouselImages';
import { getCarouselVideos } from './getCarouselVideos';
import { TMediaItemSchema } from '../../components/Carousel/interfaces';
import { IState } from '../../store';

export function getCarouselMedia(state: IState): TMediaItemSchema[] {
  const images = getCarouselImages(state);
  const videos = getCarouselVideos(state);

  return [...images, ...videos];
}
